import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=043a3df2&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=043a3df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a3df2",
  null
  
)

export default component.exports